<template>
  <section class="base-search" @touchstart="handleClick" @click="handleClick">
    <div class="base-search-inner">
      <q-input
        v-model="searchInput"
        :placeholder="t('general.type_here')"
        style="width: 100%"
        borderless
        :disable="props.disabled"
        :maxlength="20"
      />
      <base-button
        class="hover-scale-light"
        icon-name="base/MagnifyingGlass"
        round
        :disabled="props.disabled"
        @click="emit('click')"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Notification } from "~/services/notifications/toast";
import eventBus from "~/utilities/composables/eventBus";

interface IEmits {
  (e: "typing", value: string): void;
  (e: "enter"): void;
  (e: "blur"): void;
  (e: "click"): void;
  (e: "blank"): void;
}
interface IProps {
  disabled?: boolean;
  search?: string;
}

const emit = defineEmits<IEmits>();
const props = defineProps<IProps>();
const { t } = useI18n();

const handleClick = (event: Event) => {
  if (props.disabled) {
    event.preventDefault();
    const comingSoon = new Notification({
      type: "system",
      message: t("errors.coming_soon"),
    });
    comingSoon.createNewToast();
  }
};

const searchInput = computed({
  get: () => props.search || '', 
  set: (value: string) => emit('typing', value)
});

onMounted(() => {
  eventBus.on("clear-directory-search", () => {
    searchInput.value = "";
  });
});
</script>

<style scoped lang="scss">
.base-search {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 400px;
  height: 76px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 61px;
  box-shadow: var(--shadow-card);
  background: var(--white-monochrome);
  padding: 16px;
  &-inner {
    width: 100%;
    height: 42px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0 10px 16px;
    border-radius: 40px;
    background: rgb(255, 255, 255);
  }
}

@media (max-width: 32rem) {
  .base-search {
    min-width: 345px;
    border: 1px solid var(--black-monochrome-40);
    box-shadow: unset;
  }
}
</style>
